export default __webpack_public_path__ + "static/marty-bfc40145fee16aa6593c56a290e2df13.png";